import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import Packages from "@/components/landing/Packages";
import Portfolio from "@/components/landing/Portfolio";
import Testimonials from "@/components/landing/Testimonials";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Hero />
      <HowItWorks />
      <Packages />
      <Portfolio />
      <Testimonials />
    </div>
  );
}
